// source: type/subscription_payment_method.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = Function('return this')();

goog.exportSymbol('proto.type.SubscriptionPaymentMethod', null, global);
goog.exportSymbol('proto.type.SubscriptionPaymentMethod.IdCase', null, global);
goog.exportSymbol('proto.type.SubscriptionPaymentMethodType', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.type.SubscriptionPaymentMethod = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, proto.type.SubscriptionPaymentMethod.oneofGroups_);
};
goog.inherits(proto.type.SubscriptionPaymentMethod, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.type.SubscriptionPaymentMethod.displayName = 'proto.type.SubscriptionPaymentMethod';
}

/**
 * Oneof group definitions for this message. Each group defines the field
 * numbers belonging to that group. When of these fields' value is set, all
 * other fields in the group are cleared. During deserialization, if multiple
 * fields are encountered for a group, only the last value seen will be kept.
 * @private {!Array<!Array<number>>}
 * @const
 */
proto.type.SubscriptionPaymentMethod.oneofGroups_ = [[2,3]];

/**
 * @enum {number}
 */
proto.type.SubscriptionPaymentMethod.IdCase = {
  ID_NOT_SET: 0,
  CREDIT_CARD_ID: 2,
  BANK_ACCOUNT_ID: 3
};

/**
 * @return {proto.type.SubscriptionPaymentMethod.IdCase}
 */
proto.type.SubscriptionPaymentMethod.prototype.getIdCase = function() {
  return /** @type {proto.type.SubscriptionPaymentMethod.IdCase} */(jspb.Message.computeOneofCase(this, proto.type.SubscriptionPaymentMethod.oneofGroups_[0]));
};



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.type.SubscriptionPaymentMethod.prototype.toObject = function(opt_includeInstance) {
  return proto.type.SubscriptionPaymentMethod.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.type.SubscriptionPaymentMethod} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.SubscriptionPaymentMethod.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, 0),
    creditCardId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    bankAccountId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


if (jspb.Message.GENERATE_FROM_OBJECT) {

/**
 * The raw object form of SubscriptionPaymentMethod as accepted by the `fromObject` method.
 * @record
 */
proto.type.SubscriptionPaymentMethod.ObjectFormat = function() {
  /** @type {?|undefined} */
  this.type;

  /** @type {?|undefined} */
  this.creditCardId;

  /** @type {?|undefined} */
  this.bankAccountId;
};

/**
 * Loads data from an object into a new instance of this proto.
 * @param {!proto.type.SubscriptionPaymentMethod.ObjectFormat} obj
 *     The object representation of this proto to load the data from.
 * @return {!proto.type.SubscriptionPaymentMethod}
 */
proto.type.SubscriptionPaymentMethod.fromObject = function(obj) {
  var msg = new proto.type.SubscriptionPaymentMethod();
  obj.type != null && jspb.Message.setField(msg, 1, obj.type);
  obj.creditCardId != null && jspb.Message.setField(msg, 2, obj.creditCardId);
  obj.bankAccountId != null && jspb.Message.setField(msg, 3, obj.bankAccountId);
  return msg;
};
}

/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.type.SubscriptionPaymentMethod}
 */
proto.type.SubscriptionPaymentMethod.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.type.SubscriptionPaymentMethod;
  return proto.type.SubscriptionPaymentMethod.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.type.SubscriptionPaymentMethod} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.type.SubscriptionPaymentMethod}
 */
proto.type.SubscriptionPaymentMethod.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.type.SubscriptionPaymentMethodType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreditCardId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setBankAccountId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.type.SubscriptionPaymentMethod.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.type.SubscriptionPaymentMethod.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.type.SubscriptionPaymentMethod} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.type.SubscriptionPaymentMethod.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 2));
  if (f != null) {
    writer.writeString(
      2,
      f
    );
  }
  f = /** @type {string} */ (jspb.Message.getField(message, 3));
  if (f != null) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional SubscriptionPaymentMethodType type = 1;
 * @return {!proto.type.SubscriptionPaymentMethodType}
 */
proto.type.SubscriptionPaymentMethod.prototype.getType = function() {
  return /** @type {!proto.type.SubscriptionPaymentMethodType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.type.SubscriptionPaymentMethodType} value
 * @return {!proto.type.SubscriptionPaymentMethod} returns this
 */
proto.type.SubscriptionPaymentMethod.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional string credit_card_id = 2;
 * @return {string}
 */
proto.type.SubscriptionPaymentMethod.prototype.getCreditCardId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.SubscriptionPaymentMethod} returns this
 */
proto.type.SubscriptionPaymentMethod.prototype.setCreditCardId = function(value) {
  return jspb.Message.setOneofField(this, 2, proto.type.SubscriptionPaymentMethod.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.type.SubscriptionPaymentMethod} returns this
 */
proto.type.SubscriptionPaymentMethod.prototype.clearCreditCardId = function() {
  return jspb.Message.setOneofField(this, 2, proto.type.SubscriptionPaymentMethod.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.SubscriptionPaymentMethod.prototype.hasCreditCardId = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string bank_account_id = 3;
 * @return {string}
 */
proto.type.SubscriptionPaymentMethod.prototype.getBankAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.type.SubscriptionPaymentMethod} returns this
 */
proto.type.SubscriptionPaymentMethod.prototype.setBankAccountId = function(value) {
  return jspb.Message.setOneofField(this, 3, proto.type.SubscriptionPaymentMethod.oneofGroups_[0], value);
};


/**
 * Clears the field making it undefined.
 * @return {!proto.type.SubscriptionPaymentMethod} returns this
 */
proto.type.SubscriptionPaymentMethod.prototype.clearBankAccountId = function() {
  return jspb.Message.setOneofField(this, 3, proto.type.SubscriptionPaymentMethod.oneofGroups_[0], undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.type.SubscriptionPaymentMethod.prototype.hasBankAccountId = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * @enum {number}
 */
proto.type.SubscriptionPaymentMethodType = {
  CREDIT_CARD: 0,
  BANK_ACCOUNT_TRANSFER: 1
};

goog.object.extend(exports, proto.type);
